import { render, staticRenderFns } from "./DuplicateFolderIcon.vue?vue&type=template&id=6577de13&scoped=true"
import script from "./DuplicateFolderIcon.vue?vue&type=script&lang=js"
export * from "./DuplicateFolderIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6577de13",
  null
  
)

export default component.exports